<div class="page-not-found-container">
  <div class="page-not-found-message" style="max-width:420px;margin:60px auto;padding:32px 24px;background:#fff;border-radius:16px;box-shadow:0 4px 24px rgba(0,0,0,0.08);text-align:center;">
    <div class="page-not-found-svg" style="margin-bottom:24px;">
      <svg width="120" height="120" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="40" cy="40" r="40" fill="#f44336"/>
        <text x="40" y="48" text-anchor="middle" font-size="32" fill="#fff" font-weight="bold">404</text>
      </svg>
    </div>
    <h1 style="font-size:2.2rem;font-weight:700;color:#222;margin-bottom:12px;">Page Not Found</h1>
    <p style="font-size:1.1rem;color:#555;margin-bottom:24px;">The page you are looking for does not exist or is currently unavailable.</p>
    <button class="btn btn-danger" style="background:#f44336;border-color:#f44336;padding:12px 32px;font-size:1rem;border-radius:8px;box-shadow:0 2px 8px rgba(244,67,54,0.12);color:#fff;" (click)="redirectToHome()">Go to Home</button>
  </div>
</div>
